module.exports = __webpack_public_path__ + "img/mid-import-comp.8e627f15.png";